export const en = {
  company: {
    name: "PT Prima Cipta Artifisial",
    shortName: "Prima AI",
    tagline: "Pioneering Enterprise AI Integration & Intelligent Automation",
    description:
      "PT Prima Cipta Artifisial is a premier Artificial Intelligence (AI) integration partner in Indonesia. We bridge cutting-edge AI technologies with your enterprise software ecosystem to drive limitless efficiency, autonomous agentic workflows, and measurable business ROI.",
    address: "GEDUNG FANCY MAMPANG, JL. MAMPANG PRPT. RAYA NO.151 LT 4 UNIT A7, DUREN TIGA, PANCORAN, 12760",
    email: "sales@ciptaartifisial.com",
    phone: "+628211977117",
    whatsapp: "+628211977117",
  },
  nav: {
    home: "Home",
    about: "About Us",
    services: "AI Services",
    projects: "Solution",
    contact: "Contact Us",
    consultation: "Free Consultation",
  },
  hero: {
    badge: "Trusted AI Integration Partner",
    title: "Accelerate Your Enterprise with Smart & Scalable AI Integration",
    subtitle:
      "We integrate Foundation AI models, Large Language Models (LLMs), Agentic Workflows, and Computer Vision directly into your ERP, CRM, and mission-critical business systems securely and seamlessly.",
    ctaPrimary: "Start AI Transformation",
    ctaSecondary: "Explore AI Services",
    features: [
      {
        title: "Enterprise Core Integration",
        desc: "Instant connectivity to SAP, Odoo, Oracle, CRMs, and legacy REST APIs without rewriting core architecture.",
      },
      {
        title: "Private, Secure & Encrypted",
        desc: "On-Premise or Private VPC deployment guaranteeing zero-data-retention and strict banking compliance.",
      },
      {
        title: "Autonomous Agentic AI",
        desc: "Multi-step intelligent agents capable of real-world tool execution and 24/7 business operations.",
      },
    ],
  },
  about: {
    sectionSub: "Who We Are",
    headline1: "We helping",
    headline2: "grow businesses and",
    headline3: "scale with smart, data-driven AI solutions",
    title: "Empowering Enterprises to Scale with Generative AI & Intelligent Automation",
    desc1:
      "PT Prima Cipta Artifisial was founded on the conviction that artificial intelligence must deliver tangible business outcomes for enterprises in Southeast Asia. We are not just another software vendor; we are a strategic technology integration partner guiding organizations through data readiness auditing, architecture design, and enterprise-grade deployment.",
    desc2:
      "Leveraging deep technical mastery across Large Language Models, Retrieval-Augmented Generation (RAG), Computer Vision, and Autonomous Agentic Workflows, we engineer custom AI solutions that integrate seamlessly, guarantee data privacy, and deliver transparent Return on Investment (ROI).",
    visionTitle: "Our Vision",
    visionDesc:
      "To be the premier enterprise AI integration powerhouse in Southeast Asia, elevating every industry vertical toward world-class intelligent automation.",
    missionTitle: "Our Mission",
    missionDesc:
      "To architect, deploy, and support secure, ethical, and high-impact AI systems that fundamentally maximize operational productivity and enterprise profitability.",
    whyUsSub: "Why Choose Us?",
    whyUsTitle: "The PT Prima Cipta Artifisial Advantage",
    whyUs: [
      {
        title: "Zero-Data-Retention & Full Compliance",
        desc: "Private cloud and isolated on-premise deployments fully compliant with national and global data sovereignty regulations.",
      },
      {
        title: "Veteran AI Engineering Specialists",
        desc: "Backed by certified AI research engineers, data scientists, and enterprise distributed systems architects.",
      },
      {
        title: "Customized & Built for Scale",
        desc: "Every pipeline is tailored to fit your unique operational workflows, databases, and legacy infrastructure.",
      },
      {
        title: "Measurable ROI & Transparent Metrics",
        desc: "Laser-focused on reducing operating expenditures, slashing turnaround times, and elevating precision.",
      },
    ],
  },
  services: {
    sectionSub: "Featured Services",
    title: "Comprehensive AI Integration Capabilities for Your Digital Transformation",
    viewAll: "View All Services",
    items: [
      {
        id: 1,
        slug: "enterprise-ai-integration",
        title: "Enterprise AI & LLM Integration",
        shortDesc:
          "Integrate LLMs and Generative AI into core systems (ERP, CRM, Databases, REST APIs) for natural language data interactions.",
        fullDesc:
          "We connect leading foundation AI models with ERP systems (SAP, Oracle), CRMs (Salesforce, HubSpot), distributed databases, and internal software. Empower your team to query operational data and generate analytical reports purely through natural language conversations.",
        features: [
          "SAP & Oracle ERP Connectors",
          "Private RAG Knowledge Base",
          "Role-based Access Control (RBAC)",
          "Audit Trail & End-to-End Encryption",
        ],
      },
      {
        id: 2,
        slug: "agentic-workflow-automation",
        title: "Autonomous Agentic Workflows",
        shortDesc:
          "Multi-step intelligent AI agents that orchestrate complex business operations autonomously and accurately 24/7.",
        fullDesc:
          "Deploy autonomous AI agent swarms capable of reasoning, planning multi-step tasks, calling external APIs, and executing end-to-end business workflows without repetitive human intervention.",
        features: [
          "Multi-Agent Collaborative Systems",
          "Autonomous Tool & API Execution",
          "Human-in-the-loop Fallback",
          "Self-Healing Error Recovery",
        ],
      },
      {
        id: 3,
        slug: "omnichannel-conversational-ai",
        title: "Omnichannel Conversational AI",
        shortDesc:
          "Next-generation AI Chatbots & Voice Assistants for WhatsApp, Web, and Contact Centers with transactional action execution.",
        fullDesc:
          "Build conversational assistants across WhatsApp Business API, Telegram, mobile apps, and websites that go beyond canned FAQ replies—capable of checking order statuses, verifying balances, initiating transactions, and raising CRM tickets automatically.",
        features: [
          "Official WhatsApp Business API Integration",
          "Speech & Voice Recognition AI",
          "Automated Live CRM Ticket Dispatch",
          "Real-Time Sentiment Analysis",
        ],
      },
      {
        id: 4,
        slug: "intelligent-document-processing",
        title: "Intelligent Document Processing (IDP)",
        shortDesc:
          "Automated data extraction and validation for invoices, customs documents, forms, and contracts via AI Vision & OCR.",
        fullDesc:
          "AI Vision and Transformer-driven document processing capable of ingesting structured and unstructured documents (invoices, insurance policies, IDs, legal contracts) with >99% accuracy, synced directly to your financial system.",
        features: [
          "Automated Invoice & PO Processing",
          "Document Authenticity & Anomaly Detection",
          "Multi-Language & Format Parsing",
          "Automatic Sync with ERP & Accounting",
        ],
      },
      {
        id: 5,
        slug: "computer-vision-solutions",
        title: "Computer Vision & Edge AI",
        shortDesc:
          "Real-time object detection, manufacturing quality inspection, visual recognition, and smart video analytics on Edge Devices.",
        fullDesc:
          "Deploy deep learning models on industrial cameras and edge computing hardware for microscopic manufacturing defect detection, workplace safety (PPE) compliance, automatic license plate recognition, and occupancy analytics.",
        features: [
          "99.8% Visual Quality Inspection",
          "PPE & Workplace Safety Compliance Monitoring",
          "Ultra-Low Latency Edge Deployment",
          "PLC & SCADA System Integration",
        ],
      },
      {
        id: 6,
        slug: "predictive-analytics-ai",
        title: "Predictive Analytics & Data Science",
        shortDesc:
          "Machine learning models for demand forecasting, fraud prevention, dynamic pricing, and churn mitigation.",
        fullDesc:
          "Harness your enterprise historical data with predictive machine learning algorithms to forecast demand, spot fraudulent transactions in real-time, optimize dynamic pricing strategies, and reduce customer churn.",
        features: [
          "Smart Inventory & Demand Forecasting",
          "Real-Time Financial Fraud Detection",
          "Dynamic Pricing Algorithms",
          "Interactive Executive Dashboards",
        ],
      },
    ],
  },
  serviceDetails: {
    overviewBadge: "Service Overview",
    featuresTitle: "Key Capabilities & Features",
    methodologyTitle: "AI Integration Methodology",
    outcomesTitle: "Measurable Impact & Outcomes",
    outcomesIntro: "Deploying solutions by PT Prima Cipta Artifisial guarantees heightened operational velocity, instant response, and enterprise security compliance:",
    outcomesList: [
      "Encrypted LLM & ERP/CRM Core Integration.",
      "24/7 Autonomous Multi-Agent Workflows.",
      "99.4% Precision Intelligent Document Processing (IDP).",
      "Scalable On-Premise / Private VPC Infrastructure.",
      "Real-Time Telemetry & Anomaly Detection.",
      "AI-Powered Executive Decision Support.",
    ],
    steps: [
      {
        id: 1,
        title: "01. Architecture Assessment & Data Readiness",
        content:
          "We audit your business workflows, APIs, and data repositories (ERP, CRM, SQL/NoSQL) to pinpoint the highest-impact integration avenues.",
      },
      {
        id: 2,
        title: "02. Rapid Prototyping & Proof of Concept (PoC)",
        content:
          "Deploying a working prototype within 2–3 weeks to validate model accuracy, inference latency, and business logic compatibility.",
      },
      {
        id: 3,
        title: "03. Enterprise Integration & Secure Deployment",
        content:
          "Production rollout to On-Premise or Private VPC environments featuring end-to-end encryption, strict zero-data retention, and enterprise RBAC.",
      },
      {
        id: 4,
        title: "04. 24/7 SLA Monitoring & Model Fine-Tuning",
        content:
          "Continuous telemetry monitoring, drift detection, regular fine-tuning, and thorough handover training for your internal engineering team.",
      },
    ],
    ctaTitle: "Ready to Deploy This Solution?",
    ctaDesc: "Schedule a free architectural assessment with our enterprise AI engineering team today.",
  },
  industries: {
    sectionSub: "Industry Verticals",
    sectionTitle: "AI Transformation Across Strategic Industries",
    items: [
      { key: "banking", title: "Banking & Fintech" },
      { key: "manufacturing", title: "Manufacturing & Auto" },
      { key: "logistics", title: "Logistics & Supply Chain" },
      { key: "retail", title: "Retail & E-Commerce" },
      { key: "healthcare", title: "Healthcare & Pharma" },
      { key: "education", title: "Education & EdTech" },
      { key: "fmcg", title: "FMCG & Distribution" },
    ],
  },
  industriesMarquee: {
    sectionSub: "Connectivity & Reliability",
    sectionTitle: "Real-Time AI Integration for Operational Excellence",
    items: [
      { tag: "API:ERP", number: "99.8%", text: "SAP / Oracle Real-Time Sync Status: CONNECTED" },
      { tag: "RAG:LLM", number: "<1.2s", text: "Enterprise Knowledge Inference Latency" },
      { tag: "SECURITY", number: "AES-256", text: "Zero-Data-Retention & VPC Isolated Pipeline" },
      { tag: "AGENT", number: "24/7", text: "Autonomous Multi-Agent Workflow Active" },
    ],
  },
  projects: {
    sectionSub: "Case Studies & Portfolio",
    title: "Proven Enterprise AI Integration Track Record & Outcomes",
    viewAll: "View All Case Studies",
    readMore: "Read Case Study",
    sectorLabel: "Industry:",
    clientLocationLabel: "Client / Location:",
    technologiesLabel: "Technologies:",
    impactLabel: "Quantifiable Impact:",
    items: [
      {
        id: "1",
        slug: "enterprise-rag-sap-integration",
        title: "Enterprise RAG & AI Copilot Integration on SAP ERP Core",
        client: "National Manufacturing & Distribution Conglomerate",
        industry: "Manufacturing & Supply Chain",
        location: "Jakarta, Indonesia",
        service: "Enterprise AI & LLM Integration",
        summary:
          "Implementation of a secure Retrieval-Augmented Generation (RAG) architecture synced directly with SAP ERP and multi-warehouse databases.",
        challenge:
          "The client operated over 14 regional distribution hubs with hundreds of thousands of parts SKUs stored in on-premise SAP ERP databases. Manual inventory auditing reports took over 4 hours per day. Warehouse staff struggled to locate specific spare parts across regions, and C-level executives faced significant delays in obtaining unified supply chain business intelligence.",
        solution:
          "PT Prima Cipta Artifisial architected an Enterprise AI Copilot powered by a private Retrieval-Augmented Generation (RAG) engine. We built secure connectors to SAP databases via encrypted REST/RFC protocols, embedded inventory data into a self-hosted Qdrant Vector Database, and integrated a dedicated Llama 3 70B model within an isolated private VPC. Floor managers and executives can now query the system in natural language ('What is the current stock of part X in Surabaya, and when is the next restock?') and receive verified, sub-second answers.",
        description:
          "Through a non-intrusive architecture engineered by PT Prima Cipta Artifisial, this AI integration engine functions seamlessly atop existing SAP ERP layers without altering core database schemas. Every prompt is verified via Role-Based Access Control (RBAC) in milliseconds, returning actionable and audited business intelligence.",
        deliverables: [
          "Real-Time SAP ERP & Oracle RFC/REST Synchronization Connectors",
          "Private Qdrant Vector Database with AES-256 Data-at-Rest Encryption",
          "On-Premise / Private VPC LLM Pipeline with Safety Guardrails",
          "Web & Mobile Executive AI Copilot Interface with Strict RBAC",
          "Encrypted Audit Logging & Query Latency Telemetry (< 1.2s)",
          "Demand-Driven Predictive Inter-Warehouse Stock Allocation Engine",
        ],
        impact: [
          "Executive report generation time slashed from 4 hours to 15 seconds",
          "Spare parts catalog query accuracy elevated to 99.6%",
          "45% monthly operational cost reduction in manual SQL reporting overhead",
        ],
        techs: ["Python", "FastAPI", "SAP Connector", "Qdrant Vector DB", "Llama 3 70B", "Docker", "Kubernetes"],
      },
      {
        id: "2",
        slug: "omnichannel-whatsapp-ai-agent",
        title: "Autonomous WhatsApp AI Agent for Retail & E-Commerce",
        client: "Leading National Retail & E-Commerce Network",
        industry: "Retail & E-Commerce",
        location: "Surabaya, Indonesia",
        service: "Autonomous Agentic Workflows",
        summary:
          "Multi-tier AI agent deployment on WhatsApp Business API integrated with live inventory, payment gateways, and HubSpot CRM.",
        challenge:
          "Handling over 30,000 daily incoming chat inquiries during national flash sales overwhelmed the client's support team, resulting in wait times exceeding 45 minutes. Traditional rule-based chatbots failed to understand conversational slang, check multi-branch warehouse availability, or process order payments.",
        solution:
          "We engineered an autonomous multi-agent swarm on the official WhatsApp Cloud API. The AI agent performs context-aware reasoning, verifies inventory across nearby physical stores in PostgreSQL, generates dynamic checkout payment links, and synchronizes conversational history to HubSpot CRM.",
        description:
          "Our custom AI agent understands buyer intent in both formal and colloquial Indonesian, delivers personalized product recommendations, verifies warehouse stock in real-time, and processes payments autonomously 24/7.",
        deliverables: [
          "Multi-Agent Autonomous WhatsApp Cloud API Architecture",
          "Real-Time Connectors to Inventory Database & Payment Gateway",
          "Adaptive NLP Pipeline Handling Regional Dialects & Slang",
          "Automated HubSpot CRM Ticket Dispatching & Live CSAT Dashboard",
          "Seamless Human-in-the-Loop Fallback Escalation Protocols",
          "Personalized Recommendation Engine Based on Purchase History",
        ],
        impact: [
          "92% of routine conversations resolved with zero human intervention",
          "24% increase in conversational sales checkout conversions",
          "Customer satisfaction (CSAT) rating jumped to 4.8 / 5.0",
        ],
        techs: ["Node.js", "WhatsApp Cloud API", "OpenAI GPT-4o", "PostgreSQL", "HubSpot API", "Redis", "Docker"],
      },
      {
        id: "3",
        slug: "intelligent-invoice-logistics",
        title: "Intelligent Document Processing (IDP) for Freight & Customs",
        client: "Multinational Freight Forwarding & Logistics Group",
        industry: "Logistics & Supply Chain",
        location: "Tanjung Priok, Indonesia",
        service: "Intelligent Document Processing (IDP)",
        summary:
          "Vision-LLM and adaptive OCR pipeline to ingest Bill of Lading, Tax Invoices, and Customs Declarations automatically into Oracle Financials.",
        challenge:
          "Manual data entry for thousands of freight documents (Bills of Lading, Packing Lists, Tax Invoices, and Customs Import Declarations) averaged 3 full business days per shipping batch with a 6.8% human typo rate, frequently triggering port storage demurrage penalties.",
        solution:
          "PT Prima Cipta Artifisial deployed an Intelligent Document Processing (IDP) pipeline powered by Vision-Language Models (LayoutLMv3) and adaptive OCR. The solution parses over 20 distinct document layouts in both Indonesian and English, cross-verifies tax identification numbers and totals, and syncs structured data directly to Oracle Financials.",
        description:
          "Uploaded PDFs and scans are parsed automatically within seconds, key entities such as container serials, customs codes, and due dates are extracted, and cross-referenced against ship manifest records before posting to accounting ledgers.",
        deliverables: [
          "Multi-Format Vision-LLM & OCR Pipeline for Logistics Documentation",
          "Automated Tax, Customs & Bill of Lading Validation Module",
          "Direct Synchronization Connector to Oracle ERP & Ledger Databases",
          "Human-in-the-Loop Review Dashboard for Exception Handling",
          "Encrypted Audit Trail & Authenticated Digital Archive Storage",
          "Continuous Self-Learning Model Tuning Based on User Feedback",
        ],
        impact: [
          "Document verification turnaround dropped from 3 days to 4 minutes",
          "Key-value field extraction precision attained 99.4%",
          "60% operational overhead cost reduction in document processing",
        ],
        techs: ["PyTorch", "LayoutLMv3", "Tesseract OCR", "Docker", "REST API", "Oracle DB", "FastAPI"],
      },
      {
        id: "4",
        slug: "iot-predictive-maintenance",
        title: "Industrial IoT & Predictive AI for Factory Machinery",
        client: "Automotive Precision Components Manufacturer",
        industry: "Manufacturing & Automotive",
        location: "Cikarang, West Java",
        service: "Computer Vision & Edge AI",
        summary:
          "Vibration and thermal IoT sensor deployment combined with ML models to detect mechanical wear and prevent catastrophic stamping press failure.",
        challenge:
          "Catastrophic failures on high-tonnage stamping press lines caused production losses exceeding hundreds of millions of rupiah per hour. Calendar-based preventative maintenance failed to capture microscopic bearing wear developing between scheduled shifts.",
        solution:
          "We deployed an industrial IoT sensor network connected to edge computing gateways. Machine learning anomaly detection models analyze real-time vibration telemetry and thermal spectra, providing automated early warnings up to 72 hours prior to potential mechanical failure.",
        description:
          "The Edge AI system computes hundreds of telemetry data points per second directly on the factory floor without consuming internet bandwidth, transmitting live machine health dashboards to the maintenance engineering crew.",
        deliverables: [
          "Industrial-Grade Vibration & Thermal IoT Sensor Network",
          "Edge AI Processing Units Powered by TensorFlow Lite & Industrial Compute",
          "Time-Series Anomaly Detection Model with 72-Hour Predictive Warnings",
          "Real-Time Alert Integration to WhatsApp & Factory SCADA Systems",
          "Centralized Grafana Health Dashboard for Component Trend Analytics",
          "Automated Condition-Based Maintenance SOP Dispatch Protocols",
        ],
        impact: [
          "42% reduction in unplanned factory downtime",
          "IDR 2.4 Billion saved annually in emergency repair costs",
          "28% extended lifespan of critical machine bearings and motors",
        ],
        techs: ["TensorFlow Lite", "MQTT", "Grafana", "TimescaleDB", "Raspberry Pi Industrial", "Python"],
      },
      {
        id: "5",
        slug: "computer-vision-pcb-inspection",
        title: "Computer Vision Automated Optical Inspection for Electronics",
        client: "High-Tech Electronics Assembly Plant",
        industry: "Electronics & High-Tech",
        location: "Batam, Indonesia",
        service: "Computer Vision & Edge AI",
        summary:
          "High-speed Computer Vision inspection system on production conveyor belts detecting micro-soldering defects and component misalignments.",
        challenge:
          "Human visual inspection on printed circuit boards (PCBs) suffered severe fatigue at line speeds exceeding 100+ units per minute, resulting in up to 1.8% micro-defect leakage into final packaging.",
        solution:
          "We installed high-speed industrial GigE Vision cameras with calibrated illumination rigs, paired with customized YOLOv8 deep learning models running on NVIDIA DeepStream to inspect solder bridging, missing components, and reversed polarity in 8 milliseconds per board.",
        description:
          "Every circuit board passing the inspection station is photographed and analyzed in real-time. Defective boards are instantly sorted out of the conveyor line via PLC-controlled pneumatic actuators.",
        deliverables: [
          "GigE Vision Industrial Camera & Calibrated Optical Lighting Hardware",
          "YOLOv8 Deep Learning Model Optimized with NVIDIA TensorRT",
          "PLC Hardware Actuator Integration for Automated Defect Ejection",
          "Real-Time Production Quality Dashboard & Defect Pareto Analytics",
          "Defect Image Repository for Auditability & Continuous Model Tuning",
        ],
        impact: [
          "Defect detection accuracy elevated to 99.8%",
          "Real-time inspection speed of 120 units per minute with zero lag",
          "Zero defective assemblies passed to final packaging stage",
        ],
        techs: ["OpenCV", "YOLOv8", "NVIDIA DeepStream", "CUDA", "C++", "Industrial GigE Vision"],
      },
      {
        id: "6",
        slug: "dynamic-pricing-retail",
        title: "Dynamic Pricing Engine & AI Demand Forecasting",
        client: "FMCG Wholesale & Retail Distributor",
        industry: "FMCG & Distribution",
        location: "Jakarta, Indonesia",
        service: "Predictive Analytics & Data Science",
        summary:
          "Machine learning forecasting pipeline for automated competitive price adjustments and seasonal inventory replenishment.",
        challenge:
          "Volatile raw material costs and intense marketplace price competition eroded gross profit margins when price adjustments were performed manually once a week. In addition, dead-stock accumulation frequently occurred due to inaccurate purchase forecasting.",
        solution:
          "PT Prima Cipta Artifisial developed an automated Dynamic Pricing Engine ingesting market data, search volume trends, historical price elasticity, and warehouse levels to generate optimal daily price recommendations.",
        description:
          "Machine learning models evaluate profitability per SKU category and adjust live prices according to corporate business rules and minimum margin constraints set by executive management.",
        deliverables: [
          "Real-Time Machine Learning Dynamic Pricing Algorithm",
          "Automated ETL Pipeline via Apache Airflow & Google BigQuery",
          "30-Day Seasonal Supply & Demand Forecasting Model",
          "Interactive Rule-Engine & Minimum Margin Control Dashboard",
          "Early Warning System for At-Risk Slow-Moving Inventory",
        ],
        impact: [
          "14% net profit margin uplift across key categories",
          "28% reduction in warehouse dead-stock inventory",
          "94.2% demand forecasting accuracy over 30-day horizons",
        ],
        techs: ["LightGBM", "Scikit-Learn", "Apache Airflow", "BigQuery", "React Dashboard", "Python"],
      },
    ],
  },
  projectDetails: {
    pageTitle: "Case Study Details",
    overviewTitle: "Executive Summary",
    challengeTitle: "Business Challenge & Context",
    solutionTitle: "AI Integration Solution & Architecture",
    architectureHighlights: "Solution Scope & Deliverables",
    roiTitle: "Quantifiable Impact & ROI",
    techStackTitle: "Technologies & AI Models Deployed",
    serviceLabel: "Service :",
    clientLabel: "Client :",
    locationLabel: "Location :",
    industryLabel: "Industry :",
    solutionScopeTitle: "Solution Scope & Deliverables",
    solutionScopeDesc:
      "To resolve legacy constraints and scalability bottlenecks, PT Prima Cipta Artifisial architected and deployed a comprehensive integration blueprint:",
    solutionDeliverables: [
      "Isolated On-Premise RAG & Vector Database Architecture",
      "Real-Time SAP ERP Data Synchronization Connectors (REST/RFC)",
      "Bilingual Indonesian/English NLP Pipeline with Safety Guardrails",
      "Executive Analytics Management Dashboard & Mobile App Interface",
    ],
    roiDesc:
      "The solution was deployed on-schedule and generated measurable operational improvements from month one:",
    ctaTitle: "Ready to Build a Similar AI Solution for Your Enterprise?",
    ctaDesc:
      "Schedule a complimentary architectural assessment and feasibility study with our enterprise AI engineering team today.",
  },
  awards: {
    sectionSub: "Credibility & Standards",
    sectionTitle: "Enterprise Standards & Security Accreditations",
    intro:
      "PT Prima Cipta Artifisial adheres to the highest data protection protocols and AI engineering best practices to ensure rock-solid enterprise reliability.",
    items: [
      {
        year: "2024",
        title: "ISO/IEC 27001 Certified Security Pipeline",
        org: "International Organization for Standardization",
        desc: "Enterprise-grade information security management certification across our entire AI integration pipeline and deployment architecture.",
      },
      {
        year: "2024",
        title: "Enterprise AI Solution Partner of the Year",
        org: "Southeast Asia Tech Excellence Forum",
        desc: "Top enterprise AI innovation award for generative AI and supply chain integration across the manufacturing sector.",
      },
      {
        year: "2023",
        title: "Top Autonomous Agentic Workflow Pioneer",
        org: "Indonesia Digital Innovation Summit",
        desc: "Recognized for technology leadership in architecting autonomous multi-agent AI systems for business process automation.",
      },
    ],
  },
  stats: {
    title: "Our Track Record & Credibility",
    subtitle: "Trusted by national and multinational corporations to lead their AI transformation",
    items: [
      { number: "50+", label: "Successful AI Integrations" },
      { number: "99.4%", label: "Average Model Accuracy" },
      { number: "10x", label: "Workflow Velocity Gain" },
      { number: "24/7", label: "Monitoring & Dedicated SLA" },
    ],
  },
  faq: {
    sectionSub: "Frequently Asked Questions",
    title: "Everything You Need to Know About Our Enterprise AI Integration",
    items: [
      {
        q: "How does PT Prima Cipta Artifisial ensure our enterprise data privacy and security?",
        a: "Security is our fundamental priority. We offer On-Premise or Private VPC deployments (AWS/Azure/GCP) with a strict Zero-Data-Retention policy. Your proprietary data is never shared with third-party model providers. All data is encrypted in transit and at rest with AES-256.",
      },
      {
        q: "What is the typical timeframe for an enterprise AI integration project?",
        a: "Depending on workflow complexity, a functional Proof of Concept (PoC) is typically delivered within 2–3 weeks, followed by a full production rollout in 6–10 weeks.",
      },
      {
        q: "Do we need to replace our existing ERP, CRM, or database systems?",
        a: "No. Our integration solutions are non-intrusive and modular, connecting directly to your current SAP, Oracle, SQL/NoSQL databases, and internal APIs.",
      },
      {
        q: "What ongoing support and maintenance do you provide post-deployment?",
        a: "We provide 24/7 telemetry monitoring, model drift detection, periodic fine-tuning, and guaranteed emergency technical response SLAs.",
      },
    ],
  },
  contact: {
    sectionSub: "AI Consultation",
    title: "Ready to Transform Your Enterprise with AI Integration?",
    subtitle: "Schedule an architectural assessment and AI integration roadmap with our specialists today.",
    trustedAgency1: "Trusted Partner in",
    trustedAgency2: "AI Integration",
    deliveredProjects: "Projects Successfully Delivered",
    satisfactionRate: "Client Satisfaction Rate on Our Results",
    formTitle: "Send Message & Request Consultation",
    formSubtitle: "Our engineering team will get back to you within 24 business hours.",
    nameLabel: "Full Name*",
    emailLabel: "Corporate Email Address*",
    phoneLabel: "Phone Number / WhatsApp*",
    serviceLabel: "Select Integration Service*",
    messageLabel: "Describe Your Business Case / Requirements...",
    filePlaceholder: "Attach Project Brief...",
    submitBtn: "Submit Consultation Request",
    submitEmailBtn: "Send via Official Email",
    submitWhatsAppBtn: "Send via WhatsApp (Instant)",
    emailSending: "Sending to Email...",
    emailSuccess: "Your consultation request has been delivered to our official email!",
    whatsappNotice: "Opening official WhatsApp with your inquiry details...",
    chooseMethod: "Choose Delivery Channel:",
    successMsg: "Thank you! Your message has been sent successfully. Our team will contact you shortly.",
    serviceOptions: [
      "Enterprise AI & LLM Integration",
      "Autonomous Agentic Workflows",
      "Omnichannel Conversational AI",
      "Intelligent Document Processing (IDP)",
      "Computer Vision & Edge AI",
      "Predictive Analytics & Data Science",
      "AI Strategy Assessment & Consulting",
    ],
    validation: {
      required: "This field is required.",
      email: "Invalid email address.",
      numeric: "Must be a number.",
    },
  },
  errorPage: {
    pageTitle: "Page Not Found",
    title: "Hi, Sorry We Can’t Find That Page!",
    desc: "Oops! The page you are looking for does not exist. It might have been moved or deleted.",
    backBtn: "Back to Home",
  },
  footer: {
    desc: "PT Prima Cipta Artifisial is a trusted partner for enterprise AI integration, LLMs, and advanced workflow automation across Southeast Asia.",
    quickLinks: "Quick Links",
    servicesTitle: "Our Services",
    contactTitle: "Contact Office",
    rights: "All Rights Reserved.",
  },
};
